import { useRef } from "react";

function base64ToBlob(b64, mime = "audio/mpeg") {
  const byteChars = atob(b64);
  const arr = new Uint8Array(byteChars.length);
  for (let i = 0; i < byteChars.length; i++) arr[i] = byteChars.charCodeAt(i);
  return new Blob([arr], { type: mime });
}

/**
 * Encapsulates audio element + base64 playback for TTS replies.
 * Returns { audioRef, play } where audioRef goes on a hidden <audio/>.
 */
export default function useTTSPlayer() {
  const audioRef = useRef(null);

  const play = (b64) => {
    if (!b64 || !audioRef.current) return;
    const blob = base64ToBlob(b64);
    const url = URL.createObjectURL(blob);
    audioRef.current.src = url;
    audioRef.current.play().catch((err) => {
      if (process.env.NODE_ENV !== "production") {
        if (process.env.NODE_ENV === "development") {
          console.warn("Autoplay blocked or failed (non-critical):", err);
        }
      }
    });
  };

  return { audioRef, play };
}
